<template>
  <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">{{reason.attributes['reason']}}</td>
  <td class="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
    <button v-on:click="openEdit" type="button" class="mr-3 inline-flex items-center px-2.5 py-1.5 border border-gray-300 shadow-sm text-xs font-medium rounded text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
      <PencilIcon class="-ml-0.5 mr-2 h-4 w-4" />
      {{ $t('actions.edit') }}
    </button>
    <button v-on:click="askRemove" type="button" class="inline-flex items-center px-2.5 py-1.5 border border-gray-300 shadow-sm text-xs font-medium rounded text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
      <TrashIcon class="-ml-0.5 mr-2 h-4 w-4" aria-hidden="true" />
      {{ $t('actions.remove') }}
    </button>
    <ReasonDelete v-if="showRemove" v-bind:reason="reason" v-on:delete-finished-event="removeReason" />
    <ReasonEdit v-if="showEdit" v-bind:reasonObject="reason" v-on:update-finished-event="editEnded" />
  </td>
</template>


<script>
import { TrashIcon } from '@heroicons/vue/outline'
import { PencilIcon } from '@heroicons/vue/solid';

import ReasonDelete from './ReasonDelete'
import ReasonEdit from './ReasonEdit'

export default {
  name: 'ReasonListItem',
  props: ['reason'],
  emits: ['delete-event', 'edit-event'],
  components: {
    ReasonDelete,
    ReasonEdit,
    //
    TrashIcon,
    PencilIcon,
  },
  computed: {
  },
  methods: {
    askRemove() {
      this.showRemove = true;
    },
    removeReason() {
      this.showRemove = false;
      this.$emit('delete-event');
    },
    openEdit() {
      this.showEdit = true;
    },
    editEnded() {
      this.showEdit = false;
      this.$emit('edit-event');
    }
  },
  data() {
    return {
      showRemove: false,
      showEdit: false,
    }
  },
}
</script>
